export default {
	title: '传感器自诊断',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功',
		requiredError: '必填项不能为空'
	},
	buttons: {
		add: '新增',
		batchDelete: '批量删除',
		edit: '修改',
		delete: '删除',
		export: '导出',
		exporting: '导出中',
		diagnose: '诊断'
	},
	table: {
		projectNo: '项目编号',
		deviceName: '所属设备',
		pointName: '测点名称',
		sensorNo: '传感器编号',
		sensorStatus: '传感器状态',
		onlineStatus: '通讯状态',
		abnormalCause: '异常原因',
		lastEigenTime: '最新特征值',
		lastWaveTime: '最新波形',
		collectionData: '最新采集数据',
		action: '操作'
	},
	form: {
		placeholder: {
			name: '测点名称',
			projNo: '项目编号',
			pointNo: '传感器编号',
			deviceName: '所属设备',
			sensorStatus: '传感器状态',
			onlineStatus: '通讯状态',
			orgId: '机构 (诊断)',
			device: '设备选择'
		},
		label: {
			project: '所属项目',
			pointName: '测点名称',
			model: '型号',
			org: '机构 (诊断)',
			device: '设备',
			direction: '安装方向',
			pointNo: '测点编号',
			sort: '排序',
			diagnoseGroup: '状态评估模型组'
		},
		options: {
			normal: '正常',
			abnormal: '异常',
			online: '在线',
			offline: '离线'
		}
	},
	config: {
		gridLayout: '格栅布局'
	},
	dialog: {
		add: '新增',
		update: '修改'
	}
}
